import { Reveal, Overline } from "./Reveal";
import karensImg from "@/assets/karens_kitchen.png";
import { Snowflake, Clock, Heart } from "lucide-react";
import { useLightbox } from "./Lightbox";

const PERKS = [
  { icon: Snowflake, label: "Stock your freezer" },
  { icon: Clock, label: "Quick & easy meals" },
  { icon: Heart, label: "Made with love" },
];

export const Karens = () => {
  const lightbox = useLightbox();
  return (
  <section
    id="karens"
    data-testid="karens-section"
    className="py-24 md:py-40 bg-surface/40 border-y border-line/40"
  >
    <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-14 lg:gap-20 items-center">
      <Reveal className="lg:col-span-6">
        <div className="relative bg-[#F3EFE6] rounded-sm p-3 md:p-4 shadow-[0_30px_80px_-20px_rgba(0,0,0,0.6)] max-w-md mx-auto cursor-zoom-in group" onClick={() => lightbox?.open(karensImg, "Karen's Kitchen")}>
          <img
            src={karensImg}
            alt="Karen's Kitchen — hearty, home cooked meals from scratch, ready to cook from frozen, Pewsey, Wiltshire"
            className="w-full h-auto rounded-sm transition-transform duration-500 group-hover:scale-[1.02]"
            data-testid="karens-image"
          />
        </div>
      </Reveal>

      <Reveal delay={0.12} className="lg:col-span-6">
        <Overline>A thoughtful local touch</Overline>
        <h2 className="font-serif font-light tracking-tight leading-[0.95] text-textMain text-4xl md:text-5xl lg:text-6xl mt-6">
          Dinner sorted, the easy way
        </h2>
        <p className="font-sans text-textMuted leading-relaxed mt-8 max-w-xl">
          Don't fancy heading to the shop or ordering a takeaway? We can stock your freezer with <span className="text-textMain">Karen's Kitchen</span> — hearty, home-cooked meals made from scratch in nearby Pewsey, ready to cook whenever hunger strikes. Real ingredients, real food, made with love. Just let us know and we'll happily arrange it.
        </p>

        <div className="mt-10 grid grid-cols-3 gap-4">
          {PERKS.map((p) => (
            <div
              key={p.label}
              className="border border-line/60 rounded-lg p-5 flex flex-col gap-4 hover:border-primary/50 transition-colors duration-400"
            >
              <p.icon className="w-5 h-5 text-primary" strokeWidth={1.5} />
              <span className="font-sans text-sm text-textMain/85 leading-snug">{p.label}</span>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
  );
};
